import { render, staticRenderFns } from "./defaultSection.vue?vue&type=template&id=b5069904&scoped=true&"
import script from "./defaultSection.vue?vue&type=script&lang=js&"
export * from "./defaultSection.vue?vue&type=script&lang=js&"
import style0 from "./defaultSection.vue?vue&type=style&index=0&id=b5069904&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5069904",
  null
  
)

export default component.exports